import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getBoxAccessToken = createAsyncThunk(
  'GET_BOX_ACCESS_TOKEN',
  async (params: { boxDocumentId: number }, { signal }) => {
    const response = await axios.get(
      `/embeddings/box_access_token/${params.boxDocumentId}`,
      { signal },
    );

    return response.data.result;
  },
);

export default getBoxAccessToken;
